import { useCustomQuery } from '../../graphql';

interface FindAssignableAccountsForFeatureFilter {
  featureId: string;
  assignments?: string[];
  keyword?: string;
}

interface PageRequest {
  offset?: number;
  limit?: number;
}

export const FIND_FEATURE_ASSIGNABLE_ACCOUNTS = `
  query FindAssignableAccounts(
    $filter: FindAssignableAccountsForFeatureFilter!
    $page: PageRequest
    $orderBy: OrderByInput
  ) {
    feature {
      findAssignableAccounts(filter: $filter, page: $page, orderBy: $orderBy) {
        items {
          id
          name
          email
          phone
        }
        count
        offset
        limit
      }
    }
  }
`;

export const useFindAssignableAccounts = (
  filter: FindAssignableAccountsForFeatureFilter,
  page?: PageRequest
) => {
  const { data, isPending } = useCustomQuery({
    query: FIND_FEATURE_ASSIGNABLE_ACCOUNTS,
    cacheKey: [
      'feature',
      'assignable-accounts',
      filter.featureId,
      filter.keyword,
    ],
    variables: { filter, page },
  });

  return { data, isPending };
};
